import styled from "styled-components";

export const TabelaMPCalor = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 10px;
`;